import { cn } from '@/lib/utils'
import SectionHead from '@/v2/components/sections/landing-pages/section-head'
import SectionWrapper from '@/v2/components/wrappers/section-wrapper'
import { CardType } from '@/v2/types/cards'
import { motion } from 'framer-motion'
import React, { useState } from 'react'

interface PaginationSectionProps {
  title: string
  description?: string
  className?: string
  isBgDark?: boolean
  imgClassName?: string
  sectionTitleClassName?: string
  articles: CardType[]
  articlesPerPage: number
  ArticleComponent: React.FC<{ article: CardType }>
}

const PaginationSection: React.FC<PaginationSectionProps> = ({
  title,
  description,
  className,
  isBgDark = false,
  sectionTitleClassName,
  articles,
  articlesPerPage,
  ArticleComponent
}) => {
  const cardBackground = isBgDark ? 'bg-[#F9F8F8]' : 'bg-[#fff]'
  const [currentPage, setCurrentPage] = useState(1)

  // Calculate indexes
  const totalPages = Math.ceil(articles.length / articlesPerPage)
  const startIdx = (currentPage - 1) * articlesPerPage
  const currentArticles = articles.slice(startIdx, startIdx + articlesPerPage)

  return (
    <motion.section className={cn('landing-pages-wr section-spacing', cardBackground, className)}>
      <SectionWrapper>
        <SectionHead title={title} description={description} className={sectionTitleClassName} />

        {/* Articles Grid */}
        <div className='grid lg-mn:grid-cols-4 md-mn:grid-cols-2 grid-cols-1 gap-5'>
          {currentArticles.map(article => (
            <ArticleComponent key={article.id} article={article} />
          ))}
        </div>

        {/* Pagination Controls */}
        <div className='flex justify-center gap-2 mt-6'>
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i}
              className={cn('px-4 py-2 rounded', currentPage === i + 1 ? 'bg-heading-home text-white' : 'bg-gray-200')}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </button>
          ))}
        </div>
      </SectionWrapper>
    </motion.section>
  )
}

export default PaginationSection
